import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { SettingsTemplatesComponent } from './settings-templates/settings-templates.component';
import { SettingsEmployeesComponent } from './settings-employees/settings-employees.component';
import { SettingsService } from './settings.service';
import { ShareBillingCodesService } from './share-billing-codes.service';
import {
	AutoCompleteModule, CalendarModule, DialogModule, DropdownModule, TooltipModule,
	ProgressSpinnerModule
} from 'primeng/primeng';
import { SettingResource, Client, EmployeeEditHistoryResource } from 'resteasytox';
import { SettingsEmployeesHistoryComponent } from './settings-employee-edit-history/settings-employee-edit-history.component';
import {ResteasyClientFactoryService} from '../shared/resteasy-client-factory.service';
import { environment } from 'environments/environment';
import { Daterangepicker } from 'ng2-daterangepicker';
import { EmployeeEditHistoryAddModalComponent } from './settings-employee-edit-history/employee-edit-history-add-modal/employee-edit-history-add-modal.component';
import { EmployeeEditHistoryEditModalComponent } from './settings-employee-edit-history/employee-edit-history-edit-modal/employee-edit-history-edit-modal.component';

export function employeeEditHistoryResourceFactory(): EmployeeEditHistoryResource  {
	const resteasyClientFactory: ResteasyClientFactoryService = new ResteasyClientFactoryService();
	const client: Client = resteasyClientFactory.createAuthenticatedClient(environment.apiUrl + '/');
	return new EmployeeEditHistoryResource(client);
}

@NgModule({
	imports: [
		SharedModule,
		AutoCompleteModule,
		CalendarModule,
		AutoCompleteModule,
		DropdownModule,
		CalendarModule,
		Daterangepicker,
		TooltipModule,
		DialogModule,
		ProgressSpinnerModule
	],
	declarations: [
		SettingsTemplatesComponent,
		SettingsEmployeesComponent,
		SettingsEmployeesHistoryComponent,
		SettingsEmployeesComponent,
		EmployeeEditHistoryAddModalComponent,
		EmployeeEditHistoryEditModalComponent,
	],
	exports: [
		SettingsTemplatesComponent,
		SettingsEmployeesComponent
	],
	providers: [
		SettingsService,
		ShareBillingCodesService,
		ResteasyClientFactoryService,
		{
			provide: 'EmployeeEditHistoryResource',
			useFactory: employeeEditHistoryResourceFactory,
			deps: []
		}
	],
	entryComponents: [
		SettingsTemplatesComponent,
		SettingsEmployeesComponent,
	]
})
export class SettingsModule { }



// WEBPACK FOOTER //
// ./src/app/settings/settings.module.ts